import React, { useState } from 'react'
import { useDispatch } from 'react-redux'

import UploadDeliverabilityReportModalBody from './UploadDeliverabilityReportModalBody'
import { hideReduxModal } from 'Reducers/UI/actions'
import { uploadDeliverabilityReportGQL } from './gql'
import { getBase64 } from './utils'
import { processCsvFile } from '../../../Utils/Misc'
import { showReduxModal } from '../../../Reducers/UI/actions'

const UploadFile = ({ campaignDeliverabilityId }) => {
  const [file, setFile] = useState(null)
  const [isLoading, setIsLoading] = useState(false)
  const dispatch = useDispatch()
  const onCancel = () => dispatch(hideReduxModal())

  const onSubmit = async () => {
    setIsLoading(true)
    const csvData = await processCsvFile(file)

    if (csvData.errors && csvData.errors.length) {
      return dispatch(
        showReduxModal({
          title: 'Upload failed',
          children: `Reason: ${csvData.errors
            .map(({ message }) => message)
            .join('. ')}`,
          confirmLabel: `OK`,
          hideCancel: true,
        }),
      )
    }

    // TODO Refactor to upload directly to the S3 and send only URL to our API
    const base64 = await getBase64(file)
    await uploadDeliverabilityReportGQL({
      reportFile: base64.replace('application/vnd.ms-excel', 'text/csv'),
      campaignDeliverabilityId,
    })

    setIsLoading(false)

    setFile(null)

    onCancel()

    // TODO Refactor to update using React way
    setTimeout(() => {
      // Wait till fade out animation ends
      window.location.reload()
    }, 150)
  }

  return (
    <UploadDeliverabilityReportModalBody
      onSubmit={onSubmit}
      onCancel={onCancel}
      isDisabled={!file}
      setFile={setFile}
      isLoading={isLoading}
    />
  )
}

export default UploadFile
